// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CLJh5Cu_aRgSLV8YHWjj,.NPJYXuJ4xevfBxxone5J{margin-bottom:30px}.kLitUg0eNgliIfOJoVtT,.xzF8qGTNWs7SglvZ0Egw{margin-bottom:30px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"programListCardWrapper": `CLJh5Cu_aRgSLV8YHWjj`,
	"programListCardWrapper": `NPJYXuJ4xevfBxxone5J`,
	"programListEmpty": `kLitUg0eNgliIfOJoVtT`,
	"programListEmpty": `xzF8qGTNWs7SglvZ0Egw`
};
module.exports = ___CSS_LOADER_EXPORT___;
